import { ResponseData, LocationData } from '../types';

export default function formatLocationData(
  data: ResponseData
): Pick<LocationData, 'city' | 'state' | 'zip'> {
  const { city, zip5: zip } = data;
  const state = data.state ?? data.stateAbbreviation;

  if (!city || !state || !zip) {
    throw new Error('Missing required location data');
  }

  return { city, state, zip };
}
